import { FlowManager } from '../../flow-management/FlowManager';
import { Step } from '../../views/Step';
import { getSignupDataValue } from '../../store/signup-data/selectors';
import { Data } from '../../signup-data/DATA';
import { getExperimentFromState, getIsActiveAndAssignedToVariant, arePortalExperimentsFetched } from '../../store/experiments/selectors';
import { ExperimentKeys } from '../../experiments/ExperimentKeys';
import { experimentsEnabled } from '../../experiments/ExperimentUtils';
import { getIsNewPortalCreated } from '../../store/app/selectors';
export const SKIP_USE_CASE = 'skip-use-case';

const shouldRemoveHubInterestStep = state => {
  const hasUserSubmittedUseCase = getSignupDataValue(state, Data.UseCase) && getSignupDataValue(state, Data.UseCase) !== SKIP_USE_CASE;
  return hasUserSubmittedUseCase;
};

const shouldRemoveUseCaseStep = state => {
  const isExperimentsDisabled = !experimentsEnabled();
  const havePortalExperimentsFetched = arePortalExperimentsFetched(state);
  const isExperimentStatePresent = !!getExperimentFromState(state, ExperimentKeys.ONBF016_RELEASE); // The experiment is inactive in Laboratory

  const isExperimentInactive = havePortalExperimentsFetched && !isExperimentStatePresent; // This prevents a lack of Laboratory response counting the
  // Use Case release as Control.

  const hasUseCaseExperimentInformation = isExperimentInactive || isExperimentStatePresent;
  const isUseCasesReleaseControl = !getIsActiveAndAssignedToVariant(state, ExperimentKeys.ONBF016_RELEASE, ['release']);
  return isExperimentsDisabled || hasUseCaseExperimentInformation && isUseCasesReleaseControl;
};

export const BranchUseCase = {
  name: 'BranchUseCase',
  stateCheck: state => getIsNewPortalCreated(state) && (shouldRemoveHubInterestStep(state) || shouldRemoveUseCaseStep(state)),
  rebuildFlow: (flow, state) => {
    const stepToRemove = shouldRemoveUseCaseStep(state) ? Step.UseCase : Step.HubInterest;
    return FlowManager.removeSteps(stepToRemove)(flow);
  },
  processed: false,
  processedOnStep: null,
  afterData: null,
  afterStep: null
};